


export type ProjectReportType = 'Unknown' | 'RegieAbrechnen' | 'Ausmass' | 'Pauschal' | 'RegieMitAkont' | 'RegieWarten';

export const ProjectReportType = {
    Unknown: 'Unknown' as ProjectReportType,
    RegieAbrechnen: 'RegieAbrechnen' as ProjectReportType,
    Ausmass: 'Ausmass' as ProjectReportType,
    Pauschal: 'Pauschal' as ProjectReportType,
    RegieMitAkont: 'RegieMitAkont' as ProjectReportType,
    RegieWarten: 'RegieWarten' as ProjectReportType
};

